/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import { setWelfareAnimation } from '../../../rootStore';
import './index.scss';

class WelfareGuideDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.Log = this.props.Log;
  }

  componentDidMount() {
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));

	  setWelfareAnimation();
	}

  contentRender = () => {
    const { confirmCb } = this.props;
    return <div className="dialog">
      <div className="close" onClick={this.close} log-click-elname={`defaultsign_popup_${this.props.isLogin ? 'login' : 'unlogin'}_cancel`} log-click-eltype="defaultsign"></div>
      {this.defaultContent() }
      {<div className="btn" onClick={() => confirmCb && confirmCb()} log-click-elname="defaultsign_popup_login_confirm" log-click-eltype="defaultsign">点击领取</div>
      }
    </div>;
  }

	defaultContent = () => (
				<React.Fragment>
					<div className="chahua"></div>
					<div className="successTip">立即领取奖励</div>
				</React.Fragment>
	    )

	render() {
	  return (
			<div className="WelfareGuideDialog">
				{this.contentRender()}
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, isLogin } = state;
  return {
    dialogs,
    isLogin,
  };
};

export default connect(mapStateToProps)(WelfareGuideDialog);
